import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_DETAILS } from './url-constants';

type AlarmDetailsEndpointSpecification = ApiEndpointSpecification;
export const AlarmDetailsEndpointSpecification: AlarmDetailsEndpointSpecification = {
    url: ALARM_DETAILS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'AlarmDetailsRequestParams',
    requestBodySchemaName: 'AlarmDetailsRequestBody',
    okResponseSchemaName: 'AlarmDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeAlarmDetails = Helpers.makeApiRequestFn<
    Types.AlarmDetailsRequestParams,
    Types.AlarmDetailsRequestBody,
    Types.AlarmDetailsOkResponse
>(AlarmDetailsEndpointSpecification);
